<script>
import get from 'lodash/get'
import filter from 'lodash/filter'
import map from 'lodash/map'

import Field from './../components/Field.vue'
import EventBus from './../eventBus.js'

export default {
    name: 'donation',
    props: [],
    components: {
        Field,
    },
    data() {
        return {
		needrecepit: 0,
		rtyoe: 0,
		fieldTimestamp: '',
        }
    },
    computed: {
        donationFields() {
            return {
                timestamp: this.fieldTimestamp,
                data: filter(get(this, '$children'), (v, k) => {
                    return v.$options.name === 'field' && v.scope === 'donation'
                })
            }
        },
        hasFieldError() {
            return filter(this.donationFields.data, (v) => {
                return get(v, 'status') === 'error'
            }).length > 0
        },
    },
    mounted() {
        EventBus.$on('update-basic-field', (key, value) => this.updateBasicField(key, value))
    },
    methods: {
        updateBasicField(key, value) {
            this.fieldTimestamp = new Date().getTime()
        },
	rec(){
		this.needrecepit = 1 - this.needrecepit;
	},
	rec1(v){
	//alert(v);
		this.rtyoe = v;
	},
	expendrec()
	{
		return this.needrecepit;
	},
	getRType()
	{
		return this.rtyoe;
	},
        validate() {
            this.fieldTimestamp = new Date().getTime()
            const fields = filter(get(this, '$children'), (v, k) => {
                return v.$options.name === 'field' && v.scope === 'donation'
            })
            const validations = map(fields, (v) => {
                return v.validateField()
            })
            return Promise.all(validations)
        },
        submit() {
            this.validate().then(() => {
                if (this.hasFieldError) {
                    alert('請填寫必要項目')
                } else {
                    this.$refs.form.submit()
                }
            })
        },
    },
}
</script>
